import * as _4 from 'lodash4';

export class RouterHelper {
  constructor(private $state: ng.ui.IStateService, private $timeout: ng.ITimeoutService, private log: any) {}

  isValidState(stateName: string): boolean {
    return !_4.isNull(this.$state.href(stateName));
  }

  getStateInHierarchy(stateName: string): false | string {
    if (this.isValidState(stateName)) {
      return stateName;
    }
    if (!this.$state.current.name || this.$state.current.name.split('.').length === stateName.split('.').length) {
      return false;
    }
    if (_4.startsWith(stateName, '.')) {
      return this.getStateInHierarchy(`^${stateName}`);
    }
    return this.getStateInHierarchy(`^.${stateName}`);
  }

  navigateFromRouter(deferred: angular.IDeferred<any>, stateName?: ng.ui.IState['name']) {
    if (!stateName || _4.isEmpty(stateName)) {
      return deferred.resolve();
    }

    const TIME_TO_FIX_ANGULAR_STATE_ERROR = 10;

    // when navigation failed, we show error notification which we don't want here
    this.log.disable();

    this.$timeout(() => {
      this.log.enable();
      this.$state.go(stateName);
    }, TIME_TO_FIX_ANGULAR_STATE_ERROR);

    deferred.reject();
  }

  findStateAndGo(stateName: string, parameters?: object): angular.IPromise<any> | false {
    const validStateName = this.getStateInHierarchy(stateName);
    if (!validStateName) {
      return false;
    }
    return this.$state.go(validStateName, parameters);
  }
}

angular.module('capability-ng-academic-planner').service('routerHelper', RouterHelper);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/helpers/router_helper.ts